import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hyd-tests',
  template: require('./hyd-tests.component.html'),
  // styles: [require('./hyd-tests.component.css')]
  styles: [require('./hyd-tests.component.css').toString()]
})
export class HydTestsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  closeOverlay() {
    document.getElementById('HydOverlay').style.display = 'none';
  }
  overlayOpen() {
    document.getElementById('HydOverlay').style.display = 'block';
    const modal = document.getElementById('HydOverlay');
    // When the user clicks anywhere outside of the modal, this closes it
    window.onclick = function(event) {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
    };
  }

}
